<template>
  <div class="spot-the-not-container">
    <div v-if="ready == true">
      <Timer time="90"></Timer>
      <Category :category="`${this.clickedImages}/${totalImages}`"></Category>
      <div class="spot-the-not-image">
        <img :src="`${baseUrl}spot-the-not/${images[0].image}`" />
        <Canvas v-for="(value, index) in images[0].canvases" :key="index" :image="`${baseUrl}spot-the-not/${value.image}`" :imageLeft="value.imageLeft" :imageTop="value.imageTop" :id="`canvas-${index}`" :top="value.top" :left="value.left" :width="value.width" :height="value.height" @click.native="showOverlay"></Canvas>
        <Button v-if="buttonText == 'Skip'" :key="this.path" :color="this.color" :buttonText="this.buttonText" @click.native.prevent="clickSkip"></Button>
        <Button v-if="buttonText == 'Next'" :key="this.path" :color="this.color" :buttonText="this.buttonText" @click.native.prevent="clickNext"></Button>
      </div>
    </div>
    <div v-else>
      <loading :active="true"
        :color="`#fff`"
        :is-full-page="true"></loading>
    </div>
  </div>
</template>

<script>
import Timer from '@/components/Timer'
import Category from '@/components/Category'
import Button from '@/components/Button'
import Canvas from '@/components/Canvas'
import eventBus from '@/eventBus'

import SpotTheNotService from '@/services/SpotTheNotService'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'spotTheNotImage',
  components: {
    Button,
    Category,
    Timer,
    Canvas,
    Loading
  },
  data() {
    return {
      images: [],
      buttonText: "Skip",
      color: "",
      path: "",
      baseUrl: process.env.BASE_URL,
      totalImages: 0,
      clickedImages: 0,
      ready: false
    }
  },
  methods: {
    shuffle(array) {
      let currentIndex = array.length;
      let temporaryValue, randomIndex;

      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array
    },
    showOverlay(e) {
      const container = document.querySelector('.spot-the-not-image')
      const overlay = e.target.dataset.image
      const imageLeft = e.target.dataset.imageLeft
      const imageTop = e.target.dataset.imageTop

      e.target.style.pointerEvents = "none"

      const elem = document.createElement('img')
      elem.src = overlay
      elem.style.position = 'absolute'
      elem.classList.add('overlay')
      elem.style.top = imageTop
      elem.style.left = imageLeft

      container.appendChild(elem)

      this.clickedImages += 1

      this.$store.dispatch('addPoints')

      if(this.clickedImages == this.totalImages) {
        this.buttonText = "Next"
        this.color = "orange"
      }
    },

    clickNext() {
      this.images.shift()

      if(this.images.length < 1) {
        eventBus.$emit("reset-timer")
        this.$router.push({ path: '/times-up', query: { game: "2" }})
      }

      let overlays = document.querySelectorAll('.overlay')
      let canvases = document.querySelectorAll('canvas')

      overlays.forEach(element => {
        element.parentNode.removeChild(element)
      })

      canvases.forEach(element => {
        element.style.pointerEvents = "all"
      })
    
      this.totalImages = this.images[0].canvases.length
      this.clickedImages = 0

      this.buttonText = "Skip"
      this.color = ""
    },

    clickSkip() {
      this.images = this.images.concat(this.images.splice(0, 1));

      let overlays = document.querySelectorAll('.overlay')
      let canvases = document.querySelectorAll('canvas')

      overlays.forEach(element => {
        element.parentNode.removeChild(element)
      })

      canvases.forEach(element => {
        element.style.pointerEvents = "all"
      })

      this.totalImages = this.images[0].canvases.length
      this.clickedImages = 0

      this.buttonText = "Skip"
      this.color = ""
      this.$store.dispatch('subtractSkipPoints')
    },

    setDefaults() {
      this.images = this.$store.getters.images
    }
  },
  created() {
    SpotTheNotService.getImages().then((resp) => {
      this.images = resp.data
      this.$nextTick(() => {
        this.shuffle(this.images)
        this.totalImages = this.images[0].canvases.length
        this.ready = true
      });
    })
  },
  beforeDestroy() {
    eventBus.$off("timer-done");
  },
  mounted() {
    this.$ga.page('/spot-the-not/images')
    eventBus.$on('timer-done', () => {
      if(this.$route.name == "spotTheNotImage") {
        this.$router.push({ path: '/times-up', query: { game: 2 }})
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  .spot-the-not-container {
    height: 100%;
    overflow: hidden;
  }

  .spot-the-not-image {
    height: 779px;
    left: 50%;
    position: absolute;
    top: 80px;
    transform: translateX(-50%);
    width: 1247px;
    z-index: 1;
  }

  .category {
    top: 800px;
    z-index: 3;
  }

  .timer {
    top: -40px;
  }

  canvas {
    z-index: 3;
  }

  .overlay {
    z-index: 3
  }

  button {
    bottom: -30px;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    z-index: 4;
  }
</style>
